// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--9GVdV";
export var fadeUp = "navigation-module--fadeUp--dDw8U";
export var link = "navigation-module--link--ojp9f";
export var links = "navigation-module--links--nBHnp";
export var linksVisible = "navigation-module--links--visible--HTPWy";
export var navLink = "navigation-module--nav-link--3qjhn";
export var navigation = "navigation-module--navigation--qbp3g";